import React from "react";
import { Link } from "react-router-dom";
import ClientPicture from "./ClientPicture";
import { getClientLogoUrl } from "../firebase/storage";
import IconButton from "./IconButton";

class ProjectsDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showList: false,
      searchString: "",
      selectedClient: undefined,
      selectedClientLogo: null
    };

    this.onSearch = this.onSearch.bind(this);
    this.showList = this.showList.bind(this);
    this.closeList = this.closeList.bind(this);
  }

  showList(event) {
    event.preventDefault();

    if (this.props.clientChangeable !== true) return;

    this.setState({ showList: true }, () => {
      document.addEventListener("click", this.closeList);
    });
  }

  closeList(event) {
    if (
      this.dropdownMenu !== null &&
      !this.dropdownMenu.contains(event.target)
    ) {
      this.setState({ showList: false, searchString: "" }, () => {
        document.removeEventListener("click", this.closeList);
      });
    }
  }

  renderListItem(value) {
    return (
      <Link key={value.id} to={`/dash/projects/${value.id}`}>
        <div className="ProjectsDropdown-T2">
          <ClientPicture clientId={value.id} account={this.props.account} />
          <p>{value.name}</p>
        </div>
      </Link>
    );
  }

  //<StatusBadge status={value.status} />

  componentWillMount() {
    this.fetchClientInfo(this.props);
  }

  componentWillReceiveProps(props, state) {
    this.fetchClientInfo(props);
  }

  fetchClientInfo(props) {
    if (props.selectedClientId === undefined) {
      //Ersten Client
      this.setState({ selectedClient: props.clients[0] });
    } else {
      //Client von Id
      const selectedClients = props.clients.filter(
        c => c.id === props.selectedClientId
      );
      if (selectedClients.length <= 0) {
        //Unbekannte Id | Einfach den ersten Client nehmen
        this.setState({ selectedClient: props.clients[0] });
      } else {
        //Client gefunden
        this.setState({
          selectedClient: selectedClients[0]
        });

        getClientLogoUrl(
          this.props.account.id,
          selectedClients[0].id,
          url => {
            this.setState({
              selectedClientLogo: url
            });
          },
          error => {
            this.setState({
              selectedClientLogo: null
            });
          }
        );
      }
    }
  }

  onSearch(event) {
    this.setState({ searchString: event.target.value });
  }

  render() {
    if (this.props.clients.length <= 0) return null;

    const { selectedClientLogo, selectedClient } = this.state;

    let results = 0;
    const items = this.props.clients.map((value, index, arr) => {
      if (
        value.name
          .toLowerCase()
          .search(this.state.searchString.toLowerCase()) !== -1 &&
        (arr.length < 10 || value.id !== selectedClient.id)
      ) {
        results++;
        return this.renderListItem(value);
      } else return null;
    });

    const dropdownClasses =
      "ProjectsDropdownPanel" + (this.state.showList ? "" : " PopupHide-Mid");

    return (
      <div className="ProjectsDropdown">
        <div className={dropdownClasses}>
          <div
            className="ProjectsDropdown-T2"
            ref={element => {
              this.dropdownMenu = element;
            }}
          >
            <i className="fas fa-search" />
            <input
              noBorder
              type="text"
              value={this.state.searchString}
              placeholder="Nach Kunden suchen"
              onChange={this.onSearch}
            />
          </div>
          {results <= 0 ? (
            <div className="ProjectsDropdown-T2">
              <p>Leider ergab Ihre Suche keine Treffer</p>
            </div>
          ) : null}
          {items}
        </div>

        <div className="ProjectsDropdown-T1" onClick={this.showList}>
          <img alt="" src={selectedClientLogo} />
          <p>{selectedClient.name}</p>
          {this.props.clientChangeable ? (
            <IconButton id="ProjectsDropdown-Expand" icon="caret-down" />
          ) : null}
        </div>
        {this.props.clientChangeable ? (
          <div id="ProjectsDropdown-Divider" />
        ) : null}
        {this.props.clientChangeable ? (
          <Link to="clients#add">
            <IconButton id="ProjectsDropdown-Add" icon="plus" />
          </Link>
        ) : null}
      </div>
    );
  }
}

export default ProjectsDropdown;



// WEBPACK FOOTER //
// ./src/components/ProjectsDropdown.js